import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../stylesheets/style.scss";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Col, Button, FormGroup, Label, Input, Spinner } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { Feedback_APIs } from "./Feedback_APIs";
import { Ticket_Variables } from "../ticketModule/variables/Ticket_Variables";
import { UserConsumer } from "../../UserContext";
import CustomReactSelect from "../../components/CustomReactSelect";
import { AlertPopups } from "../../components/AlertPopups";

const validation = Yup.object().shape({
	selectPriority: Yup.string()
		.required("Select Priority")
		.typeError("Invalid input")
		.nullable(),
	Description: Yup.string()
		.required("Description is required")
		.typeError("Invalid input")
		.max(600, "Max 600 characters allowed"),
	title: Yup.string()
		.required("Title is required")
		.typeError("Invalid input")
		.max(500, "Max 500 characters allowed"),
});
let token = null;
class CreateFeedback extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectPriority: null,
			Description: "",
			title: "",
			attachment: "",
			hidden: true,
			fileErr: false,
			loading: false,
		};
	}
	handleChange = (temp, displayCode, event) => {
		if (displayCode === 3) {
			this.setState({
				[event.name]: temp,
			});
		} else if (displayCode === 1) {
			this.setState({
				[temp.target.name]: temp.target.value.replace(
					new RegExp(`/^([\w\(\),@'\\./!#-&$*+=^~-])/gm`)
				),
			});
		} else if (displayCode === 2) {
			if (temp.target.files[0] !== undefined) {
				this.setState({ fileErr: false });
				if (
					["image/jpeg", "image/jpg", "image/png"].includes(
						temp.target.files[0].type
					)
				) {
					this.setState({
						attachment: temp.target.files[0],
					});
				} else {
					this.setState({
						fileErr: true,
					});
				}
			}
		} else if (displayCode === 4) {
			document.getElementById("attachment").value = null;
			this.setState(
				{
					attachment: "",
				},
				() => {
					if (document.getElementById("icon")) {
						document.getElementById("icon").remove();
					}
				}
			);
		}
	};

	handleSubmit = () => {
		if (
			this.state.fileErr === false &&
			this.state.title &&
			this.state.Description
		) {
			AlertPopups.confirmBox
				.fire({
					text: `Create Feedback`,
				})
				.then((result) => {
					if (result.value) {
						let self = this;
						let formdata = new FormData();
						formdata.append("Title", self.state.title);
						formdata.append("Description", self.state.Description);
						formdata.append(
							"Priority",
							self.state.selectPriority.value
						);
						if (self.state.attachment !== null) {
							formdata.append(
								"Attachment",
								self.state.attachment
							);
						}
						const headers = {
							Authorization: `Bearer ${token}`,
						};
						self.setState({ loading: true });
						axios
							.post(
								`${Feedback_APIs.CreateFeedback_API}`,
								formdata,
								{
									headers: headers,
								}
							)
							.then(function (response) {
								self.setState(
									{
										loading: false,
										title: "",
										Description: "",
										attachment: "",
										selectPriority: null,
									},
									() => {
										document.getElementById(
											"attachment"
										).value = null;
										self.props.reloadList();
									}
								);
							})
							.catch(() => {
								AlertPopups.WarningAlert.fire({
									text: `Try again please`,
								});
								self.setState({ loading: false });
							});
					}
				});
		}
	};
	render() {
		return (
			<div>
				<UserConsumer>
					{(userDetails) => {
						token = userDetails.token;
						return (
							<Formik
								initialValues={this.state}
								enableReinitialize={true}
								validationSchema={validation}
								validateOnChange={true}
								onSubmit={() => {
									this.handleSubmit();
								}}
							>
								{({ errors, handleSubmit }) => (
									<form
										onSubmit={handleSubmit}
										className="itemReqForm"
									>
										<FormGroup
											row
											id="row0"
											className="bottom-spacing topBorders "
										>
											<Label sm={12}>
												Create Feedback
											</Label>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="title" sm={2}>
												Title
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<Input
													type="text"
													name="title"
													id="title"
													className={`formValueInput ${
														errors.title
															? "h-auto invalid"
															: "h-auto"
													}`}
													onChange={(value, event) =>
														this.handleChange(
															value,
															1,
															event
														)
													}
													value={this.state.title}
													maxLength="500"
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label for="selectPriority" sm={2}>
												Priority
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={
														Ticket_Variables.feedbackPriority
													}
													name="selectPriority"
													id="selectItems"
													onChange={(value, event) =>
														this.handleChange(
															value,
															3,
															event
														)
													}
													value={
														this.state
															.selectPriority
													}
													className={`formValueInput ${
														errors.selectPriority
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="Description" sm={2}>
												Description
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<Input
													type="textarea"
													name="Description"
													id="Description"
													className={`formValueInput ${
														errors.Description
															? "h-auto invalid"
															: "h-auto"
													}`}
													onChange={(value, event) =>
														this.handleChange(
															value,
															1,
															event
														)
													}
													value={
														this.state.Description
													}
													maxLength="600"
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2 lastRow"
										>
											<Label for="attachment" sm={2}>
												Attachment
											</Label>
											<Col sm={9} id="attachment-align">
												<Input
													type="file"
													name="attachment"
													id="attachment"
													accept="image/png,image/jpeg,image/jpg"
													onChange={(value, event) =>
														this.handleChange(
															value,
															2,
															event
														)
													}
													className="overflow-hidden"
												/>
												{this.state.fileErr && (
													<div className="input-feedback">
														Only
														".jpeg",".jpg",".png"
														type files allowed
													</div>
												)}
											</Col>
											<Col sm={1}>
												<FontAwesomeIcon
													icon={faWindowClose}
													className="att-remove-icon"
													color="keppel"
													onClick={(value, event) =>
														this.handleChange(
															value,
															4,
															event
														)
													}
													hidden={
														!this.state.attachment
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup row className="btns mt-3">
											<Button
												className="submit-btn leftBtn"
												type="submit"
												onClick={() => {
													this.handleSubmit();
												}}
											>
												Create
											</Button>
										</FormGroup>
									</form>
								)}
							</Formik>
						);
					}}
				</UserConsumer>

				{this.state.loading && (
					<div className="loader-div">
						<Spinner color="secondary" />
					</div>
				)}
			</div>
		);
	}
}
export default CreateFeedback;
